const SPACE_KNOWLEDGEBASE_TYPES = ['catalogue', 'documents', 'gallery'];
const FILE_ONLY_KNOWLEDGEBASE_TYPES = ['event_documents'];

// Tenant routing fields stamped on Qdrant payloads — not useful in the UI.
const SPACE_KB_HIDDEN_FIELDS = ['account_id', 'knowledgebase_id'];

export function isFileOnlyKnowledgebase(knowledgebase) {
  return FILE_ONLY_KNOWLEDGEBASE_TYPES.includes(knowledgebase?.type);
}

export function isImmutableSchemaKnowledgebase(knowledgebase) {
  if (isFileOnlyKnowledgebase(knowledgebase)) return true;
  if (!knowledgebase?.system) return false;
  return SPACE_KNOWLEDGEBASE_TYPES.includes(knowledgebase.type);
}


export function isHiddenSpaceKbField(fieldName, knowledgebase) {
  if (!isImmutableSchemaKnowledgebase(knowledgebase)) return false;
  return SPACE_KB_HIDDEN_FIELDS.includes(fieldName);
}

export function filterSpaceKbSchemaProperties(properties, knowledgebase) {
  if (!properties || !isImmutableSchemaKnowledgebase(knowledgebase)) {
    return properties || {};
  }

  return Object.fromEntries(
    Object.entries(properties).filter(
      ([key]) => !SPACE_KB_HIDDEN_FIELDS.includes(key)
    )
  );
}
